import { render, staticRenderFns } from "./SuggestedTemplates.vue?vue&type=template&id=5aea608a&"
import script from "./SuggestedTemplates.vue?vue&type=script&lang=ts&"
export * from "./SuggestedTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports